import { SortDescriptor } from "@/base/model/sort-descriptor";
import { Client } from "@/service/client";
import { Feedback } from "@/shared/model/feedback.model";

export class FeedbackApi {
  private client: Client;

  constructor(client: Client) {
    this.client = client;
  }

  async create(data: {
    title: string;
    description: string;
    email: string;
  }): Promise<Feedback> {
    const response = await this.client.fetch(`/feedback`, {
      method: "POST",
      body: JSON.stringify(data),
    });

    const json = await response.json();

    return json.data;
  }

  async list(sortDescriptor: SortDescriptor): Promise<Feedback[]> {
    const response = await this.client.fetch(
      `/feedback?sort=${sortDescriptor.column}&order=${sortDescriptor.direction}`
    );

    const json = await response.json();

    return json.data;
  }

  async get(id: string): Promise<Feedback> {
    const response = await this.client.fetch(`/feedback/${id}`);

    const json = await response.json();

    return json.data;
  }

  async update(id: string, data: Partial<Feedback>): Promise<Feedback> {
    const response = await this.client.fetch(`/feedback/${id}`, {
      method: "PUT",
      body: JSON.stringify(data),
    });

    const json = await response.json();

    return json.data;
  }

  async delete(id: string): Promise<void> {
    await this.client.fetch(`/feedback/${id}`, {
      method: "DELETE",
    });
  }

  async createComment(
    id: string,
    data: { content: string; email: string }
  ): Promise<void> {
    await this.client.fetch(`/feedback/${id}/comment`, {
      method: "POST",
      body: JSON.stringify(data),
    });
  }
}
